import {
  AbstractControl,
  type ValidationErrors,
  type ValidatorFn,
} from '@angular/forms';

/**
 * Accepts Unicode letters, spaces, apostrophes, hyphens, and periods.
 * Blocks digits and unsupported special characters.
 *
 * Examples that pass: "John", "José", "O'Connor", "Smith-Jones", "J.J. Abrams"
 * Examples that fail: "John1", "John@", "Jane#Doe"
 */
const NAME_REGEX = /^(?=.*\p{L})[\p{L}\s.'-]+$/u;

/**
 * Creates a name validator that accepts alphabetic characters (including
 * Latin/accented letters such as é, ü, ñ), spaces, apostrophes, hyphens,
 * and periods. Digits and unsupported special characters are rejected.
 *
 * @returns A `ValidatorFn` that emits `{ required: true }` when blank or
 *          `{ invalid: true }` when the value contains non-letter characters.
 */
export function nameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value as string | null | undefined)?.trim() ?? '';

    if (!value) {
      return { required: true };
    }

    if (!NAME_REGEX.test(value)) {
      return { invalid: true };
    }

    return null;
  };
}
